import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({ breakpoints }: Theme) => ({
  root: {
    marginBottom: '2rem',
    '& .smart-captcha': {
      width: '100%',
      minWidth: 'unset',
      height: '10rem !important',
      [breakpoints.up('sm')]: {
        height: '6.5rem !important',
      },
    },
  },
}));
